import Loadable from 'react-loadable';

export const PricingApiDoc = Loadable({
  loader: () => import('./PricingApiDoc'),
  loading: () => null,
});


// WEBPACK FOOTER //
// ./src/containers/PricingApiDoc/index.ts